export const ADMIN = "Admin";
export const LEARNER = "Learner";
export const INSTRUCTOR = "Instructor";